import { urls } from './paths';

const textAlert = {
  textTitle: '¿Quieres pedir Gas por la Web?',
  urlText: 'Pedir Gas',
  url: urls.orderGas,
};

export { textAlert };
